var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.61,
    height: 19.61,
    viewBox: "0 0 19.61 19.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(-1457.37 -313.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M1461.04,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1461.04,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M1461.04,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1461.04,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M1461.04,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1461.04,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M1461.04,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1461.04,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M1463.05,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1463.05,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M1463.05,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1463.05,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M1463.05,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1463.05,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M1463.05,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1463.05,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M1465.07,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1465.07,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M1465.07,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1465.07,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M1465.07,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1465.07,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M1465.07,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1465.07,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M1468.71,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1468.71,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M1468.71,319.48h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.373.373,0,0,0,1468.71,319.48Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M1468.71,317.18h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.373.373,0,0,0,1468.71,317.18Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M1468.71,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1468.71,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M1468.71,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1468.71,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M1468.71,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.368.368,0,0,0,1468.71,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M1470.72,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.374.374,0,0,0,1470.72,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M1470.72,319.48h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1470.72,319.48Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M1470.72,317.18h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1470.72,317.18Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M1470.72,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.374.374,0,0,0,1470.72,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M1470.72,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.374.374,0,0,0,1470.72,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M1470.72,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.374.374,0,0,0,1470.72,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M1472.73,321.77h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1472.73,321.77Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M1472.73,319.48h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.386.386,0,0,0,1472.73,319.48Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M1472.73,317.18h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.386.386,0,0,0,1472.73,317.18Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M1472.73,324.07h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1472.73,324.07Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M1472.73,326.37h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1472.73,326.37Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M1472.73,328.67h.57a.38.38,0,0,0,.38-.38v-.57a.38.38,0,0,0-.38-.38h-.57a.38.38,0,0,0-.38.38v.57A.38.38,0,0,0,1472.73,328.67Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M1461.8,331.16a.38.38,0,0,0,0,.76h.01a.38.38,0,1,0-.01-.76Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M1469.46,331.16a.38.38,0,1,0,0,.76h.01a.38.38,0,1,0-.01-.76Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M1457.76,332.69h0a.38.38,0,1,0-.01.76h.01a.38.38,0,0,0,0-.76Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M1476.6,332.69h0a.38.38,0,1,0-.01.76h.01a.38.38,0,1,0,0-.76Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M1475.49,332.69h-.27V314.22a.38.38,0,0,0-.38-.38h-7.66a.38.38,0,0,0-.38.38v4.67h-7.28a.38.38,0,0,0-.38.38v13.41h-.27a.38.38,0,0,0,0,.76h16.62a.38.38,0,0,0,.38-.38A.371.371,0,0,0,1475.49,332.69Zm-10.23,0h-1.53v-1.53h1.53Zm1.53,0h-.77v-1.92a.38.38,0,0,0-.38-.38h-2.3a.38.38,0,0,0-.38.38v1.92h-3.06v-.77h.81a.38.38,0,0,0,0-.76h-.81V319.67h6.9v13.02Zm6.13,0h-1.53v-1.53h1.53Zm1.53,0h-.77v-1.92a.38.38,0,0,0-.38-.38H1471a.38.38,0,0,0-.38.38v1.92h-3.07v-.77h.81a.38.38,0,1,0,0-.76h-.81V314.61h6.9Z",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityIcon);
export default __webpack_public_path__ + "static/media/CityIcon.538f07451b3bf6b4044d87f16ffe13e7.svg";
export { ForwardRef as ReactComponent };